import React from 'react';
import CertificatesComponent from '../../components/proStudent/Certificates/Certificates';

const Certificates = () => {
  return (
    <div>
      <CertificatesComponent />
    </div>
  );
};

export default Certificates;
